module.exports = __webpack_public_path__ + "static/media/instructivor1.34278607.png";